import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-slider--right",
  "use": "icon-slider--right-usage",
  "viewBox": "0 0 20 7",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 7\" id=\"icon-slider--right\"><path d=\"M14.7 6.552c.28-.597.55-1.12.812-1.568.28-.448.55-.821.812-1.12H0V2.688h16.324c-.261-.317-.532-.7-.812-1.148A22.697 22.697 0 0 1 14.7 0h.98c1.176 1.363 2.408 2.37 3.696 3.024v.504c-1.288.635-2.52 1.643-3.696 3.024h-.98Z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol